<template>
  <div class="page page__list">
    <div class="filter-bar">
      <span>
        {{ activeTab }}
        <i class="caret"></i>
      </span>
      <select class="filter-item__select" v-model="activeTab" @change="select">
        <option :value="item.name" v-for="(item, index) in list" :key="index">
          {{ item.name }}&nbsp;&nbsp;&nbsp;<span v-if="item.num">{{
            item.num
          }}</span>
        </option>
      </select>
    </div>
    <div class="weui-cells" v-if="tableList && tableList.length > 0">
      <router-link
        v-for="(items, index2) in tableList"
        :key="index2"
        :to="{ name: 'LitigationDetail', params: { items, activeTab } }"
      >
        <div v-if="activeTab == '开庭公告'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.caseOrigin }}</p>
          </div>
          <div class="weui-cell__ft">
            <p class="list-item-muted">{{ items.listPage.caseNumber }}</p>
            <p class="list-item-muted">
              {{ items.listPage.courtDate }}
            </p>
          </div>
        </div>
        <div v-if="activeTab == '法院公告'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.caseOrigin }}</p>
          </div>
          <div class="weui-cell__ft">
            <p class="list-item-muted">{{ items.listPage.caseNumber }}</p>
            <p class="list-item-muted">
              {{ items.listPage.publishDate }}
            </p>
          </div>
        </div>
        <div v-if="activeTab == '终本案件'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.personEnforcement }}</p>
            <p class="list-item-muted">{{ items.listPage.caseNumber }}</p>
          </div>
          <div class="weui-cell__ft">
            <p class="list-item-muted">
              {{ items.listPage.filingCaseDate }}
            </p>
          </div>
        </div>
        <div
          v-if="activeTab == '失信被执行人'"
          class="weui-cell weui-cell_access"
        >
          <div class="weui-cell__bd">
            <p>{{ items.listPage.breachPersonExecution }}</p>
            <p class="list-item-muted">{{ items.listPage.caseNumber }}</p>
          </div>
          <div class="weui-cell__ft">
            <p class="list-item-muted">
              {{ items.listPage.filingCaseDate }}
            </p>
          </div>
        </div>
        <div v-if="activeTab == '被执行人'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.personEnforcement }}</p>
            <p class="list-item-muted">{{ items.listPage.caseNumber }}</p>
          </div>
          <div class="weui-cell__ft">
            <p class="list-item-muted">
              {{ items.listPage.filingCaseDate }}
            </p>
          </div>
        </div>
        <div v-if="activeTab == '股权冻结'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.stockEnterprise }}</p>
            <p class="list-item-muted">
              {{ items.listPage.executionNoticeNumber }}
            </p>
          </div>
          <div class="weui-cell__ft">
            <p class="list-item-muted">
              {{ items.listPage.announcementDate }}
            </p>
          </div>
        </div>
        <div v-if="activeTab == '限制消费令'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.croTargets }}</p>
            <p class="list-item-muted">
              {{ items.listPage.caseNumber }}
            </p>
          </div>
          <div class="weui-cell__ft">
            <p class="list-item-muted">
              {{ items.listPage.filingCaseDate }}
            </p>
          </div>
        </div>
        <div v-if="activeTab == '送达公告'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.caseOrigin }}</p>
            <p class="list-item-muted">
              {{ items.listPage.announcementName }}
            </p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.court }}</p>
            <p class="list-item-muted">
              {{ items.listPage.releaseDate }}
            </p>
          </div>
        </div>
        <div v-if="activeTab == '立案信息'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.caseOrigin }}</p>
            <p class="list-item-muted">
              {{ items.listPage.court }}
            </p>
          </div>
          <div class="weui-cell__ft">
            <p class="list-item-muted">
              {{ items.listPage.filingCaseDate }}
            </p>
          </div>
        </div>
        <div v-if="activeTab == '破产案件'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.caseNumber }}</p>
            <p class="list-item-muted">
              {{ items.listPage.court }}
            </p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.caseType }}</p>
            <p class="list-item-muted">
              {{ items.listPage.pubDate }}
            </p>
          </div>
        </div>
        <div v-if="activeTab == '司法拍卖'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>
              {{ items.listPage.appointCourt }}
            </p>
            <p class="list-item-muted">
              {{ items.listPage.auctionDate }}
            </p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.startingPrice }}</p>
          
          </div>
        </div>
        <div v-if="activeTab == '询价评估'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.caseNumber }}</p>
            <p class="list-item-muted">
              {{ items.listPage.court }}
            </p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.inquiryResult }}</p>
            <p class="list-item-muted">
              {{ items.listPage.releaseDate }}
            </p>
          </div>
        </div>
      </router-link>
    </div>
    <div class="empty" v-else>暂无数据</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: "开庭公告",
      list: [
        {
          name: "开庭公告",
          num: 0,
        },
        {
          name: "法院公告",
          num: 0,
        },
        {
          name: "终本案件",
          num: 0,
        },
        {
          name: "失信被执行人",
          num: 0,
        },
        {
          name: "被执行人",
          num: 0,
        },
        {
          name: "股权冻结",
          num: 0,
        },
        {
          name: "限制消费令",
          num: 0,
        },
        {
          name: "送达公告",
          num: 0,
        },
        {
          name: "立案信息",
          num: 0,
        },
        {
          name: "破产案件",
          num: 0,
        },
        {
          name: "司法拍卖",
          num: 0,
        },
        {
          name: "询价评估",
          num: 0,
        },
      ],
      tableList: [],
    };
  },
  created() {
    this.loadData();
    this.select();
  },
  methods: {
    select() {
      let me = this,
        name = me.$route.query.name;
      if (!name || name == "") {
        return;
      }

      me.$loading({
        url:
          "/api/document/eOperatingRisk/getLawsuitInfo?name=" +
          name +
          "&riskName=" +
          me.activeTab,
      }).then(function (res) {
        if (res.data) {
          me.tableList = res.data;
        }
      });
     
    },
    loadData() {
      let me = this,
        name = me.$route.query.name;
      if (!name || name == "") {
        return;
      }

      me.$loading({
        url: "/api/document/eOperatingRisk/lawsuitCount?name=" + name,
      }).then(function (res) {
        if (res.data) {
          me.list.forEach((item) => {
            for (const key in res.data) {
              if (key == item.name) {
                item.num = res.data[key];
              }
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.page {
  margin-top: 50px;
}
.empty {
  width: 100%;
  height: 300px;
  line-height: 300px;
  text-align: center;
  color: #727272;
  font-weight: bold;
}
.filter-bar {
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  position: relative;
}
.filter-bar span {
  margin: 0 auto;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
.text-hide {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.weui-cell {
  border-top: 1px solid #eee;
}
.weui-cells {
  overflow-y: scroll;
}
.weui-cells > a:first-child > .weui-cell {
  border-top: 0;
}
</style>